import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AnalyticsService {
  dataHiredResign: BehaviorSubject<any>;
  dataStateTickets: BehaviorSubject<any>;
  dataEmployeesRole: BehaviorSubject<any>;
  dataClientSalesVolume: BehaviorSubject<any>;
  dataRevenueReport: BehaviorSubject<any>;
  dataBudget: BehaviorSubject<any>;
  dataSkills: BehaviorSubject<any>;
  dataCandidatesForRecruiters: BehaviorSubject<any>;
  dataCandidatesOKKO: BehaviorSubject<any>;
  dataSalesCosts: BehaviorSubject<any>;
  dataEdgeForClients: BehaviorSubject<any>;
  dataMostRequestedJobs: BehaviorSubject<any>;
  dataQualifications: BehaviorSubject<any>;
  dataNegotiation: BehaviorSubject<any>;
  dataCandidatesRole: BehaviorSubject<any>;
  dataProviderAndStruturalCosts: BehaviorSubject<any>;

  //mock
  mockHiredResign = {
    series: [
      {
        name: "Assunti",
        type: "column",
        data: [4, 2, 5, 10, 1, 5, 13, 22, 24, 14, 21, 30],
      },
      {
        name: "Dimessi",
        type: "column",
        data: [1, 1, 2, 4, 2, 1, 3, 5, 6, 13, 9, 11],
      },
    ],
    xaxis: {
      categories: ["Gen 2023", "Feb 2023", "Mar 20230", "Apr 2023", "Mag 2023", "Giu 2023", "Lug 2023", "Ago 2023", "Set 2023", "Ott 2023", "Nov 2023", "Dic 2023"],
    },
  };

  mockStateTickets = {
    series: [83],
    labels: ["Ticket completati"],
  };

  mockEmployeesRole = {
    series: [44, 55, 13, 24, 22],
    labels: ["Sviluppatori FE", "Sviluppatori BE", "HR", "Analisti", "Manager"],
  };

  mockClientSalesVolume = {
    series: [40000000, 270000000, 208000000, 330000000, 170000000, 13000000, 50000000],
    labels: ["Azienda 1", "Azienda 2", "Azienda 3", "Azienda 4", "Azienda 5", "Azienda 6", "Azienda 7"],
  };

  mockRevenueReport = {
    series: [
      {
        name: "Entrate",
        data: [95, 177, 284, 256, 105, 63, 168, 218, 72],
      },
      {
        name: "Uscite",
        data: [-145, -80, -60, -180, -100, -60, -85, -75, -100],
      },
    ],
  };

  mockBudget = {
    series: [
      {
        data: [61, 48, 69, 52, 60, 40, 79, 60, 59, 43, 62],
      },
      {
        data: [20, 10, 30, 15, 23, 0, 25, 15, 20, 5, 27],
      },
    ],
  };

  mockSkills = {
    series: [
      {
        name: "Angular",
        data: [
          [new Date("2020").getFullYear(), 30, 200],
          [new Date("2021").getFullYear(), 38, 250],
          [new Date("2022").getFullYear(), 50, 350],
        ],
      },
      {
        name: "Spring",
        data: [
          [new Date("2021").getFullYear(), 30, 150],
          [new Date("2021").getFullYear(), 34, 180],
          [new Date("2022").getFullYear(), 10, 200],
        ],
      },
      {
        name: "React",
        data: [
          [new Date("2022").getFullYear(), 30, 80],
          [new Date("2021").getFullYear(), 34, 150],
          [new Date("2022").getFullYear(), 28, 250],
        ],
      },
      {
        name: "Javascript",
        data: [
          [new Date("2023").getFullYear(), 40, 310],
          [new Date("2021").getFullYear(), 60, 380],
          [new Date("2022").getFullYear(), 38, 450],
        ],
      },
    ],
  };

  mockCandidatesForRecruiters = {
    series: [
      {
        name: "Candidati",
        data: [40, 43, 44, 47, 54, 58, 69],
      },
    ],
    xaxis: {
      categories: ["Maria Rossi", "Andrea Bruni", "Vittoria Di Roma", "Edoardo Mieli", "Marco Bianchi", "Stefano Gialli", "Giovanna Celeste"],
    },
  };

  mockCandidatesOKKO = {
    series: [44, 55, 23],
    labels: ["OK", "KO", "In Contrattazione"],
  };

  mockSalesCosts = {
    series: [
      {
        name: "Fatturato",
        type: "column",
        data: [4000000, 5500000, 8700000, 13000000],
      },
      {
        name: "Costi",
        type: "column",
        data: [2000000, 2200000, 4800000, 6300000],
      },
    ],
    xaxis: {
      categories: ["2019", "2020", "2021", "2022", "2023"],
    },
  };

  mockEdgeForClients = {
    series: [
      {
        name: "Fatturato",
        data: [440000, 55000, 570000, 560000, 61000],
      },
      {
        name: "Costi",
        data: [200000, 5000, 300000, 260000, 20000],
      },
      {
        name: "Margine",
        data: [240000, 50000, 270000, 300000, 41000],
      },
    ],
    xaxis: {
      categories: ["Cliente 1", "Cliente 2", "Cliente 3", "Cliente 4", "Cliente 5"],
    },
  };

  mockMostRequestedJobs = {
    series: [44, 35, 13, 43, 12],
    labels: ["Sviluppatore BE", "Sviluppatore FE", "Analista", "Manager", "Architetto"],
  };

  mockQualifications = {
    series: [89, 65, 13, 3],
    labels: ["Laureati", "Diplomati", "Licenza media", "Nessuno"],
  };

  mockNegotiation = {
    series: [24, 5, 13],
    labels: ["Chiuse", "Annulate", "In Corso"],
  };

  mockCandidatesRole = {
    series: [16, 25, 8, 24, 6],
    labels: ["Sviluppatori FE", "Sviluppatori BE", "HR", "Analisti", "Manager"],
  };

  mockProviderAndStruturalCosts = {
    series: [2600000, 750000],
    labels: ["Costi fornitori", "Costi di struttura"],
  };

  //mock

  constructor() {
    this.dataHiredResign = new BehaviorSubject({});
    this.dataStateTickets = new BehaviorSubject({});
    this.dataEmployeesRole = new BehaviorSubject({});
    this.dataClientSalesVolume = new BehaviorSubject({});
    this.dataRevenueReport = new BehaviorSubject({});
    this.dataBudget = new BehaviorSubject({});
    this.dataSkills = new BehaviorSubject({});
    this.dataCandidatesForRecruiters = new BehaviorSubject({});
    this.dataCandidatesOKKO = new BehaviorSubject({});
    this.dataSalesCosts = new BehaviorSubject({});
    this.dataEdgeForClients = new BehaviorSubject({});
    this.dataMostRequestedJobs = new BehaviorSubject({});
    this.dataQualifications = new BehaviorSubject({});
    this.dataNegotiation = new BehaviorSubject({});
    this.dataCandidatesRole = new BehaviorSubject({});
    this.dataProviderAndStruturalCosts = new BehaviorSubject({});

    this.dataHiredResign.next(this.mockHiredResign);
    this.dataStateTickets.next(this.mockStateTickets);
    this.dataEmployeesRole.next(this.mockEmployeesRole);
    this.dataClientSalesVolume.next(this.mockClientSalesVolume);
    this.dataRevenueReport.next(this.mockRevenueReport);
    this.dataBudget.next(this.mockBudget);
    this.dataSkills.next(this.mockSkills);
    this.dataCandidatesForRecruiters.next(this.mockCandidatesForRecruiters);
    this.dataCandidatesOKKO.next(this.mockCandidatesOKKO);
    this.dataSalesCosts.next(this.mockSalesCosts);
    this.dataEdgeForClients.next(this.mockEdgeForClients);
    this.dataMostRequestedJobs.next(this.mockMostRequestedJobs);
    this.dataQualifications.next(this.mockQualifications);
    this.dataNegotiation.next(this.mockNegotiation);
    this.dataCandidatesRole.next(this.mockCandidatesRole);
    this.dataProviderAndStruturalCosts.next(this.mockProviderAndStruturalCosts);
  }
}
